export const jsonParse = (data) => {
  try {
    return JSON.parse(data);
  } catch (e) {
    return data;
  }
};
